import React, {useEffect, useRef, useState} from "react";
import Panel from "../unfox-design/Panel";
import Header from "../unfox-design/Header";
import Title from "../unfox-design/Title";
import Group from "../unfox-design/Group";
import Input from "../unfox-design/Input";
import Button from "../unfox-design/Button";
import {ReCaptchaKey, TITLE} from "../../config";
import Snackbar from "../unfox-design/Snackbar";
import API from "../../API";
import ReCAPTCHA from "react-google-recaptcha";

let Register = (props) => {
    let captchaRef = useRef(null);
    let [captchaKey, SetcaptchaKey] = useState('');
    let [email, setEmail] = useState('');
    let [snack, setSnack] = useState('');
    let [code, setCode] = useState('');
    let [snackText, setSnackText] = useState('');
    let [pass1, setPass1] = useState('');
    let [login, setLogin] = useState('');
    let [pass2, setPass2] = useState('');

    let showSnack = (e, text) => {
        setSnackText(text);
        setSnack(e);
    }

    useEffect(() => {
        props.toggleNav(false);
    })

    let updateEmail = (value) => {
        setEmail(value);
    }

    let updateCode = (value) => {
        setCode(value);
    }

    let validate = () => {
        if (!email.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$')) {
            showSnack(true, '😭 Broken email!');
            return;
        }
        if (pass1.length < 6) {
            showSnack(true, '😭 Password too short');
            return;
        }
        // if (code.length < 6) {
        //     showSnack(true, '😭 Код не может быть таким коротким');
        //     return;
        // }

        if (pass1 !== pass2) {
            showSnack(true, '😭 Passwords not same');
            return;
        }

        API.execute('register', {login, password: pass1, email, captcha: captchaKey}).then(data => {
            localStorage.accessToken = data['response'];
            props.go('profile');
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            showSnack(true, `🤔 ${errorMessage}`);
        });

    }

    return (
        <Panel>
            <Header status="Register">
                {TITLE}
            </Header>
            <Group>
                <Input required type={'email'} onChange={(e) => updateEmail(e.target.value)} placeholder="Email"/>
                <Input required placeholder="Login" onChange={(e) => setLogin(e.target.value)}/>
                <Input required placeholder="Password" type="password" onChange={(e) => setPass1(e.target.value)}/>
                <Input required placeholder="Confirm Password" type="password" onChange={(e) => setPass2(e.target.value)}/>
                {/*<Input required onChange={(e) => updateCode(e.target.value)} placeholder="Инвайт-код"/>*/}
                <ReCAPTCHA
                    sitekey={ReCaptchaKey}
                    ref={captchaRef}
                    theme={'dark'}
                    onChange={(e) => SetcaptchaKey(e)}
                />
                <div style={{display: "flex", alignItems: "center"}}>
                    <Button onClick={validate} size="l">Register!</Button>
                    <a style={{margin: "0 18px"}} onClick={() => {
                        props.go('auth')
                    }}>Log in!</a>
                </div>
            </Group>

            <Snackbar start={snack} callback={() => {
                setSnack(false)
            }} vertical="bottom" duration={3000}>
                {snackText}
            </Snackbar>
        </Panel>
    )
}

export default Register;
